import { render } from "./StepWrapper.vue?vue&type=template&id=15c34496"
import script from "./StepWrapper.vue?vue&type=script&lang=js"
export * from "./StepWrapper.vue?vue&type=script&lang=js"

import "./StepWrapper.vue?vue&type=style&index=0&id=15c34496&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__